import type { SVGProps } from "react";

export function IconPerson(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M28 20H4V28H28V20Z" stroke="black" strokeWidth="1.5" />
      <path d="M23.3334 28V24" stroke="black" strokeWidth="1.5" />
      <path d="M8.66663 28V24" stroke="black" strokeWidth="1.5" />
      <mask
        id="mask0_2665_14077"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="1"
        width="16"
        height="16"
      >
        <circle
          cx="16"
          cy="9.33366"
          r="6.66667"
          fill="#D0D03E"
          stroke="#D0D03E"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_2665_14077)">
        <circle
          cx="16"
          cy="9.33366"
          r="6.66667"
          fill="#D0D03E"
          stroke="#D0D03E"
          strokeWidth="1.5"
        />
        <path
          d="M13.3334 10.0007C13.3334 10.3508 13.4023 10.6976 13.5364 11.0211C13.6704 11.3447 13.8668 11.6386 14.1144 11.8863C14.362 12.1339 14.656 12.3303 14.9796 12.4643C15.3031 12.5983 15.6498 12.6673 16 12.6673C16.3502 12.6673 16.697 12.5983 17.0205 12.4643C17.3441 12.3303 17.638 12.1339 17.8857 11.8863C18.1333 11.6386 18.3297 11.3447 18.4637 11.0211C18.5977 10.6976 18.6667 10.3508 18.6667 10.0007"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M14 8.00065C14.3333 5.00065 16 2.66732 16 2.66732C16 2.66732 17.6667 5.00065 18 8.00065H24V-0.666016H8V8.00065H14Z"
          fill="#7C7CED"
        />
        <path
          d="M16 2.66732L16.6103 2.23139H15.3897L16 2.66732ZM14 8.00065V8.75065H14.6713L14.7454 8.08348L14 8.00065ZM8 8.00065H7.25V8.75065H8V8.00065ZM18 8.00065L17.2546 8.08348L17.3287 8.75065H18V8.00065ZM24 8.00065V8.75065H24.75V8.00065H24ZM24 -0.666016H24.75V-1.41602H24V-0.666016ZM8 -0.666016V-1.41602H7.25V-0.666016H8ZM16 2.66732C15.3897 2.23139 15.3896 2.23155 15.3895 2.23172C15.3894 2.23179 15.3893 2.23197 15.3892 2.23211C15.389 2.23239 15.3888 2.2327 15.3885 2.23305C15.388 2.23374 15.3874 2.23458 15.3867 2.23556C15.3853 2.23753 15.3835 2.24007 15.3814 2.24317C15.377 2.24937 15.3711 2.25784 15.3637 2.26852C15.349 2.28988 15.3285 2.32009 15.3028 2.35876C15.2515 2.43607 15.1797 2.54732 15.0935 2.68921C14.9212 2.97272 14.69 3.38024 14.4484 3.88539C13.9674 4.89112 13.4335 6.30784 13.2546 7.91783L14.7454 8.08348C14.8999 6.69346 15.3659 5.44352 15.8016 4.53258C16.0183 4.07939 16.2247 3.71608 16.3753 3.46834C16.4505 3.34461 16.5115 3.25012 16.5527 3.18811C16.5732 3.15712 16.5888 3.13428 16.5987 3.11999C16.6036 3.11285 16.6071 3.10784 16.609 3.10504C16.61 3.10363 16.6106 3.10278 16.6108 3.10248C16.611 3.10233 16.611 3.10231 16.6109 3.10244C16.6108 3.10251 16.6108 3.10261 16.6107 3.10274C16.6106 3.10281 16.6105 3.10293 16.6105 3.10297C16.6104 3.1031 16.6103 3.10325 16 2.66732ZM14 7.25065H8V8.75065H14V7.25065ZM16 2.66732C15.3897 3.10325 15.3896 3.1031 15.3895 3.10297C15.3895 3.10293 15.3894 3.10281 15.3893 3.10274C15.3892 3.10261 15.3892 3.10251 15.3891 3.10244C15.389 3.10231 15.389 3.10233 15.3892 3.10248C15.3894 3.10278 15.39 3.10363 15.391 3.10504C15.3929 3.10784 15.3964 3.11285 15.4013 3.11999C15.4112 3.13428 15.4268 3.15712 15.4473 3.18811C15.4885 3.25013 15.5495 3.34461 15.6247 3.46834C15.7753 3.71608 15.9817 4.07939 16.1984 4.53258C16.6341 5.44352 17.1001 6.69346 17.2546 8.08348L18.7454 7.91783C18.5665 6.30784 18.0326 4.89112 17.5516 3.88539C17.31 3.38024 17.0788 2.97272 16.9065 2.68921C16.8203 2.54732 16.7485 2.43607 16.6972 2.35876C16.6715 2.32009 16.651 2.28988 16.6363 2.26852C16.6289 2.25784 16.623 2.24937 16.6186 2.24317C16.6165 2.24007 16.6147 2.23753 16.6133 2.23556C16.6126 2.23458 16.612 2.23374 16.6115 2.23305C16.6112 2.2327 16.611 2.23239 16.6108 2.23211C16.6107 2.23197 16.6106 2.23179 16.6105 2.23172C16.6104 2.23155 16.6103 2.23139 16 2.66732ZM18 8.75065H24V7.25065H18V8.75065ZM24.75 8.00065V-0.666016H23.25V8.00065H24.75ZM24 -1.41602H8V0.0839844H24V-1.41602ZM7.25 -0.666016V8.00065H8.75V-0.666016H7.25Z"
          fill="#7C7CED"
        />
      </g>
    </svg>
  );
}
